// src/utils/themeManager.js
export class ThemeManager {
  static updateTheme(hex) {
    const root = document.documentElement;
    const variations = {
      "theme-color": hex,
      "theme-color-alpha-d0": `${hex}d0`,
      "theme-color-alpha-a0": `${hex}a0`,
      "theme-color-alpha-70": `${hex}70`,
      "theme-color-alpha-30": `${hex}30`,
      "theme-color-alpha-20": `${hex}20`,
      "theme-color-alpha-10": `${hex}10`,
      "theme-color-alpha-05": `${hex}05`,
      "theme-color-light": this.lightenColor(hex, 30),
    };
    // Update CSS custom properties
    Object.entries(variations).forEach(([property, value]) => {
      root.style.setProperty(`--${property}`, value);
    });
  }
  static hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  static lightenColor(hex, percent) {
    const rgb = this.hexToRgb(hex);
    const factor = (100 + percent) / 100;

    const r = Math.min(255, Math.round(rgb.r * factor));
    const g = Math.min(255, Math.round(rgb.g * factor));
    const b = Math.min(255, Math.round(rgb.b * factor));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }
}
